<tr class="entryRow tableRow" [@zoomInOnEnter] [@zoomOutOnLeave]>
	<!--VECTOR-->
	<td>
		<sim-session-run-vector [index]="index()" />
		<mat-divider vertical class="separator" />
	</td>

	<!--TIME-->
	<td class="secondary">
		<span>
			{{ start() | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }} -
			{{ end() | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
		</span>
		<mat-divider vertical class="separator" />
	</td>

	<!--DURATION-->
	<td>
		<sim-duration-input
			[formCtrl]="form().controls.runDurationInMinutes"
			[labelToken]="T.PEER_PRACTICE_SESSION_RUN_DURATION"
			[suffixFontIcon]="'fa-stopwatch'"
			[min]="1"
			[subscriptSizing]="'dynamic'"
		/>

		@if (hasIntermission()) {
			<mat-icon fontIcon="fa-plus" fontSet="fad" class="separator" inline />
		}
	</td>

	<!--INTERMISSION-->
	<td>
		@if (hasIntermission()) {
			<sim-duration-input
				[formCtrl]="form().controls.intermissionDurationInMinutes"
				[labelToken]="T.LABEL_INTERMISSION"
				[suffixFontIcon]="'fa-coffee'"
				[min]="0"
				[subscriptSizing]="'dynamic'"
			/>
		}
	</td>

	<!--ACTIONS-->
	<td class="action">
		@if (canDelete()) {
			<button mat-icon-button color="warn" appStopPropagation (click)="store.scheduleEntryDeleted(index())" [disabled]="disabled()">
				<mat-icon fontSet="fas" fontIcon="fa-trash-alt" inline />
			</button>
		}
	</td>
</tr>
